import { render, staticRenderFns } from "./checkout_kiosk_hub_component.vue?vue&type=template&id=88dd7f04&scoped=true"
import script from "./checkout_kiosk_hub_component.vue?vue&type=script&lang=js"
export * from "./checkout_kiosk_hub_component.vue?vue&type=script&lang=js"
import style0 from "./checkout_kiosk_hub_component.vue?vue&type=style&index=0&id=88dd7f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dd7f04",
  null
  
)

export default component.exports